/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon20Regular = forwardRef('WeatherUmbrellaIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 1.5a.75.75 0 0 0-1.5 0v1.281a8.877 8.877 0 0 0-8.094 8.093A1.042 1.042 0 0 0 2.197 12H9.25v4.375a1.125 1.125 0 0 1-2.25 0c0-.448-.247-.875-.75-.875s-.75.427-.75.875a2.625 2.625 0 0 0 5.25 0V12h7.053c.591 0 1.093-.5 1.04-1.126A8.877 8.877 0 0 0 10.75 2.78V1.5Zm-8.04 9h14.58a7.377 7.377 0 0 0-14.58 0Z" })));
});
